/**
 * Last Mile monitoring component
 * Allows configuration for domains in each site\account to which the socket pings every x configured seconds
 */

mainApp.component('lastMileMonitoring', {
    templateUrl: '/public/components/last-mile-monitoring.component.html',
    bindings: {
        model: '=',
        isSiteConfiguration: '=',
        changesListener: '&',
    },
    controller: lastMileMonitoringController
});

function lastMileMonitoringController($scope, GeneralUtilsService) {
    var ctrl = this;


    ctrl.$onInit = function() {
        init();
    }

    function init(){
        //get default destinations for account and site (can be different since site can have localized destinations like in China)
       store.fetch({
            path: '/getLastMileDefaultDestinations?isSiteLevel=false',
            success: function(data) {
                ctrl.defaultDestinations = data;

                if (ctrl.isSiteConfiguration){
                   store.fetch({
                        path: '/getLastMileDefaultDestinations',
                        queryParams: {siteId: ctrl.model.id,
                                      isSiteLevel : true},
                        success: function(data) {
                            ctrl.localizedDestinations = data;

                            //reload component data
                            reload();
                        }
                    });
                }
                else {
                    reload();
                }
            }
        });
}

    //checks if there were changed in the component and calls the changes listener
    //used only in account level since site has it's on hasChanges which checks the model all way through
    ctrl.$doCheck = function() {
        if (!ctrl.changesListener)
            return;

        var isChangedNow = !angular.equals(ctrl.model.lastMileMonitRule, ctrl.original);

        //check if listener was already called and updates about having changes
        if (ctrl.hasChanges === isChangedNow)
            return;

        ctrl.hasChanges = isChangedNow;
        ctrl.changesListener({isDirty: ctrl.hasChanges, componentName: 'lastMileMonitoring'});
    }

    //the model was changed and settings need to be reloaded
     $scope.$on('modelReloadedEvent', function (event, data) {
       init();
    });


    function reload() {
        //get the settings on account level to show in case the site doesn't override it
        ctrl.isSiteConfiguration ? setRuleForSiteLevel() : setRuleForAccountLevel();
     }

     ctrl.overrideChanged = function(isOverride) {

        if (ctrl.model.lastMileMonitRule) {
            ctrl.model.lastMileMonitRule.override = isOverride;
            ctrl.currentRule = isOverride ? ctrl.model.lastMileMonitRule : ctrl.accountRule;
        }
        else if (isOverride) {
            ctrl.templateRule = getTemplateRule(true);
            ctrl.currentRule = angular.copy(ctrl.templateRule);
            ctrl.currentRule.override = true;
            ctrl.model.lastMileMonitRule = ctrl.currentRule;
        }
        else {
            ctrl.currentRule = ctrl.accountRule;
        }

        ctrl.currentDefaults = isOverride ? ctrl.localizedDestinations : ctrl.defaultDestinations;
     }

     //check if rule was changed and update the model
     ctrl.ruleChanged = function () {
        //if the rule binded to the html is different than the template we create - the user made changes
        if(!angular.equals(ctrl.currentRule, ctrl.templateRule)){
            ctrl.model.lastMileMonitRule = ctrl.currentRule;
        }
        else {
            ctrl.model.lastMileMonitRule = ctrl.model.original;
        }
    }

    //find removed interfaces and add them to ItemsToDelete on lastMilMonitRule model
    ctrl.updateInterfacesToDelete = function(selectedInterfaces){
      var itemsToDelete = [];

      if(ctrl.original && ctrl.original.excludedInterfaces){
           //for each excluded interface - try to find it in selected items
              ctrl.original.excludedInterfaces.forEach(function(item) {
               var found = false;
               for (var i = 0 ; i < selectedInterfaces.length; i++) {
                    if(item.id === selectedInterfaces[i].id){
                        found = true;
                        break;
                    }
                }

                if(!found){
                    itemsToDelete.push(item);
                }
              });

             GeneralUtilsService.addItemsToDelete(ctrl.model.lastMileMonitRule, itemsToDelete, "excludedInterfaces");
      }
    }

    //get the default rule we show in case user made no changes
    function getTemplateRule(localizedDests){
        let destinations = angular.copy(localizedDests ? ctrl.localizedDestinations : ctrl.defaultDestinations);
        return {id: GeneralUtilsService.getRandomId(), name:"", active: false , testInterval: 10, destinations: destinations , excludedInterfaces: []};
    }

    function setRuleForAccountLevel() {
         ctrl.currentDefaults = ctrl.defaultDestinations;

        //if last mile was configured on account set the rule from the model
        if (ctrl.model && ctrl.model.lastMileMonitRule){
            ctrl.currentRule = ctrl.model.lastMileMonitRule;
            ctrl.original = angular.copy(ctrl.model.lastMileMonitRule);
        }
        else {
            ctrl.templateRule = getTemplateRule(false);
            ctrl.currentRule = angular.copy(ctrl.templateRule);
        }

        ctrl.currentDefaults = ctrl.defaultDestinations;
        ctrl.datamodified = new Date().getTime();
    }

    function setRuleForSiteLevel(){

       //get account settings in case of !override by site
       store.fetch({
            path: '/getAccountLastMileSettings?siteId=' + ctrl.model.id,
            success: function(data) {

                ctrl.accountRule = data ? data : getTemplateRule(false);
                ctrl.override = ctrl.model.lastMileMonitRule ? ctrl.model.lastMileMonitRule.override : false;
                ctrl.original = angular.copy(ctrl.model.lastMileMonitRule);

                if(ctrl.model.lastMileMonitRule && ctrl.override){
                    ctrl.currentRule = ctrl.model.lastMileMonitRule;
                    ctrl.currentDefaults = ctrl.localizedDestinations;
                }
                else {
                    ctrl.currentRule = ctrl.accountRule;
                    ctrl.currentDefaults = ctrl.defaultDestinations;
                }

                ctrl.datamodified = new Date().getTime();
            }
        });
    }
};